import { Injectable } from "@angular/core";
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { ConfirmationService } from 'primeng/api';
import { RequestQuoteComponent } from "../routes/search-inventory-component/request-quote-component/request-quote.component";
import { REQUEST_STEPS } from '../routes/search-inventory-component/request-quote-component/enum-request-steps';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<RequestQuoteComponent> {
    constructor(private confirmationService: ConfirmationService, private router: Router) {
    }

    canDeactivate(component:RequestQuoteComponent,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
        nextState: RouterStateSnapshot):Promise<boolean> | boolean {

        if(nextState.url.includes('/error'))
            return true;
        if(this.checkBrowserRefresh())
            return true;
        if(component.currentStep === REQUEST_STEPS.SUBMIT)
            return true;

        return new Promise((resolve, reject) => {
            this.confirmationService.confirm({
                message: "Are you sure you want to exit this page?",
                accept: () => {
                    resolve(true);
                },
                reject: () => {
                    resolve(false);
                }
            });
        });
    }

    checkBrowserRefresh(){
        //check if browser refresh to prevent calling Exit popup incase of refresh
        const navigation = this.router.getCurrentNavigation();
        if(navigation){
            const state = navigation.extras.state;
            if(state && 'refresh' in state && state['refresh'])
                return true;
        }
        return false;
    }
}
